<template>
  <div
    :class="{'gc-navigator-bottom-bar__link--active': active }"
    class="gc-navigator-bottom-bar__link gc-navigator-bottom-bar__link--workout"
    @click="clicked()">
    <div class="gc-navigator-bottom-bar__icon">
      <icon-workout-filled
        v-if="active"
        :size="'md1'"
        class="gc-navigator-bottom-bar__link-icon gc-navigator-bottom-bar__link-icon--active"/>
      <icon-workout-linear
        v-else
        :size="'md1'"
        class="gc-navigator-bottom-bar__link-icon"/>
      <icon-underline/>
    </div>
  </div>
</template>
<script>
import IconWorkoutFilled from '../../../root/icons/IconWorkoutFilled'
import IconWorkoutLinear from '../../../root/icons/IconWorkoutLinear'
import IconDot from '../../../root/icons/IconDot'
import IconUnderline from '@/components/root/icons/IconUnderline.vue'

export default {
  name: 'NavigatorBottomBarLinkWorkout',
  components: {
    IconUnderline,
    IconDot,
    IconWorkoutLinear,
    IconWorkoutFilled
  },
  props: {
    active: {
      default: false
    }
  },
  methods: {
    clicked () {
      this.$emit('click')
    }
  }
}
</script>
